import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import { router } from './router';
import { ThemeProvider, QueryProvider, EmployeeSidePanelProvider } from './providers';

export function App() {
  return (
    <QueryProvider>
      <ThemeProvider>
        <EmployeeSidePanelProvider>
          <RouterProvider router={router} />
          <Toaster richColors position="bottom-right" />
        </EmployeeSidePanelProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
